import { useState } from 'react'
import { withStyles } from '@aura/components/styles'
import Button from '@aura/components/button'
import Box from '@aura/components/box'
import Grid from '@aura/components/grid'
import Radio from '@aura/components/radio'
import Typography from '@aura/components/typography'
import { useTranslation } from 'react-i18next'
import { useAuraThemeSwitcher } from '@aura/components/themes'
import PropTypes from 'prop-types'
import CustomLoader from '../../../../components/custom-loader'
import FetchAuthenticatorStatus from '../../../../constants/fetch-authenticators'
import RegistrationContainerNew from '../../../../components/registration-container-new'
import styles from './styles'


const Component = ({
    authenticatorStatus,
    classes,
    data,
    onSignIn
}) => {

    const { t: translate } = useTranslation()
    const { theme } = useAuraThemeSwitcher()
    const [ selectedValue, setSelectedValue ] = useState('')
    const [ hoveredType, setHoveredType ] = useState(null)

    const mfaFactors = Object.values(data).map(rec => {
        return {
            img: rec.appName === 'Okta Verify' ? `/img/okta_icon_${theme.palette.mode}.svg?url` : `/img/google_icon_${theme.palette.mode}.svg?url`,
            ...rec
        }
    })

    const isLoading = authenticatorStatus === FetchAuthenticatorStatus.PENDING

    const handleSignInClick = factorName => {
        const factor = Object.values(data).find(rec => rec.factorName === factorName)
        onSignIn(factor)
    }

    const handleChange = event => {
        setSelectedValue(event.target.value)
    }

    const footerContent = ( <Grid className={classes.buttonContainer} container item md={12} xs={12}>
        <Grid container className={classes.actionRow} justify="flex-end">
            <Button
                className={classes.buttonSubmit}
                disabled={!selectedValue}
                onClick={() => { handleSignInClick(selectedValue) }}
                variant="contained">{translate('next')}
            </Button>
        </Grid>
    </Grid>)

    const title = translate('signInAuth.multifactor')
    const verbiage = translate('signInAuth.verbiage1')

    return (
        <RegistrationContainerNew {...{ footerActions: footerContent, title, verbiage }}>
            <div className={classes.fieldsContainer}>
                {isLoading
                    ? <CustomLoader label={translate('loading')} />
                    : <></>}
                {Object.values(mfaFactors).map(({ desc, img, isRequired, factorType, factorName }, idx) => (
                    <Box
                        key={idx}
                        className={`${classes.mfaOption} 
                                    ${(hoveredType === factorName || selectedValue === factorName) && classes.mfaOptionSelected} 
                        `}
                        onMouseEnter={() => setHoveredType(factorName)}
                        onMouseLeave={() => setHoveredType(null)}
                    >
                        <Box className={classes.mfaNameContainer}>
                            <Box className={classes.mfaIconBox}>
                                <img className={classes.mfaLogo} src={img} />
                                <div className={classes.mfaTitle}>{translate(`authenticatorOptions.${factorName}`)} {isRequired ? '*' : ''}</div>
                            </Box>
                            <Typography className={classes.mfaDesc}>{translate(`authenticatorOptions.${desc}`)}</Typography>
                        </Box>
                        <Box className={classes.radioButton}>
                            <Radio
                                className={classes.radio}
                                checked={selectedValue === factorName}
                                onChange={handleChange}
                                value={factorName}
                                name="radio-buttons"
                                inputProps={{ 'aria-label': `${factorName}` }}
                            />
                        </Box>
                    </Box>
                ))}
            </div>
            <Box className={classes.warningLine}>{translate('mfaEnrollment.verbiage07')} </Box>
        </RegistrationContainerNew>
    )
}

Component.displayName = 'Authenticators'

Component.defaultProps = {
    data: {}
}

Component.propTypes = {
    authenticatorStatus: PropTypes.string,
    classes: PropTypes.shape({
        actionRow: PropTypes.object,
        button: PropTypes.object,
        buttonContainer: PropTypes.object,
        contentDivider: PropTypes.object,
        fieldsContainer: PropTypes.object,
        loader: PropTypes.object,
        mfaListContainer: PropTypes.object,
        mfaLogo: PropTypes.object,
        mfaLogoContainer: PropTypes.object,
        mfaSetupTitle: PropTypes.object,
    }),
    data: PropTypes.object,
    onSignIn: PropTypes.func
}

export default withStyles(Component, styles)